<template>
  <div id="app">
    <div class="row">
      <div class="col-12">
        <h2 class="generalTitle">Cancelaciones</h2>
      </div>
    </div>
    <div class="row mx-1">
      <div class="col-12 mb-3">
        <list-filters @filter="filter($event)" :filterURL="filterURL" />
      </div>
      <div class="col-12" v-if="cancellations && cancellations.length > 0">
        <div class="card" :class="{ 'card-versionMovil': !$store.state.responsive.viewDesktopLists}">
          <div class="card-body pb-0">
            <div class="align-items-center d-flex justify-content-between mb-1">
              <p class="mb-2">Mostrando {{ from }}-{{ to }} de {{ totalItems }} cancelaciones</p>
            </div>
            <list :cancellations="cancellations" @selectOrder="selectOrder($event)" />
            <div class="row">
              <div class="col-12 col-sm-8 col-lg-5">
                <div class="form-group" v-if="numberPages > 1">
                  <div class="float-left mr-3 mt-2">
                    <select v-model="itemsPerPage" class="form-control" id="itemsPerPage"
                      @change="changeItemsPerPage()">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                  <label for="itemsPerPage" class="col-form-label mt-2">Cancelaciones por página</label>
                </div>
              </div>
              <div class="col-12 col-sm-4 col-lg-7" v-if="numberPages > 1">
                <pagination :currentPage=currentPage :numberPages=numberPages @selectPage="selectPage($event)" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-else>
        <div class="alert alert-info">No hay resultados para mostrar</div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';
import List from './templates/List.vue';
import ListFilters from '@/components/Widgets/Shared/CancellationsListFilters.vue';
import Pagination from '@/components/Widgets/Shared/Pagination.vue';
import { useRoute } from 'vue-router';

export default {
  name: 'CancellationsList',
  data() {
    return {
      // name: '',
      // surnames: '',
      // documentNumber: '',
      // phone: '',
      shop: '',
      contractNumber: '',
      fromDate: '',
      toDate: '',
      status: '',
      cancellations: [],
      filters: '',
      itemsPerPage: 25,
      currentPage: 0,
      totalItems: 0,
      numberPages: 0,
      from: 0,
      to: 0,
      order: '',
      filtros: {
        contractId: null,
        email: null,
        // legalIdentifier: null,
        // name: null,
        // phone: null,
        // surnames: null,
        date: null,
        dateFrom: null,
        dateTo: null,
        endDate: null,
        merchant: null,
        status: null
      },
    };
  },
  components: {
    List,
    ListFilters,
    Pagination,
  },
  created() {
    const route = useRoute();
    const filterURL = route.query.filterURL;
    if(filterURL && filterURL !== '') {
      this.filterURL = filterURL;
    } else {
      this.loadContracts();
    }
  },
  methods: {
    filter(value) {
      // this.name = value.name !== undefined ? value.name : this.name;
      // this.surnames = value.surnames !== undefined ? value.surnames : this.surnames;
      // this.documentNumber = value.documentNumber !== undefined ? value.documentNumber : this.documentNumber;
      this.shop = value.shop !== undefined ? value.shop : this.v;
      this.contractNumber = value.contractNumber !== undefined ? value.contractNumber : this.contractNumber;
      this.fromDate = value.from !== undefined ? value.from : this.fromDate;
      this.toDate = value.to !== undefined ? value.to : this.toDate;
      // this.phone = value.phone !== undefined ? value.phone : this.phone;
      this.status = value.status !== undefined ? value.status : this.status;
      this.currentPage = 0;
      this.loadContracts();
    },
    // filterName() {
    //   if (this.name !== '' && this.name !== undefined) {
    //     this.filters = `${this.filters}&customer.name=${this.name}`;
    //     this.filtros.name = this.name
    //   }
    // },
    // filterSurnames() {
    //   if (this.surnames !== '' && this.surnames !== undefined) {
    //     this.filters = `${this.filters}&customer.surnames=${this.surnames}`;
    //     this.filtros.surnames = this.surnames
    //   }
    // },
    // filterDocumentNumber() {
    //   if (this.documentNumber !== '' && this.documentNumber !== undefined) {
    //     this.filters = `${this.filters}&customer.legalIdentifier=${this.documentNumber}`;
    //     this.filtros.legalIdentifier = this.documentNumber
    //   }
    // },
    filterContractNumber() {
      if (this.contractNumber !== '' && this.contractNumber !== undefined) {
        this.filters = `${this.filters}&contractId=${this.contractNumber}`;
        this.filtros.contractId = this.contractNumber
      }
    },
    filterFrom() {
      if (this.fromDate !== '' && this.fromDate !== undefined) {
        this.filters = `${this.filters}&dateFrom=${this.$dateFrontToBack(this.fromDate)}`;
        this.filtros.dateFrom = this.fromDate
      }
    },
    filterTo() {
      if (this.toDate !== '' && this.to !== undefined) {
        this.filters = `${this.filters}&dateTo=${this.$dateFrontToBack(this.toDate)}`;
        this.filtros.dateTo = this.toDate
      }
    },
    // filterPhone() {
    //   if (this.phone !== '' && this.to !== undefined) {
    //     this.filters = `${this.filters}&customer.phone=${this.phone}`;
    //     this.filtros.phone = this.phone
    //   }
    // },
    filterStatus() {
      if (this.status !== '' && this.to !== undefined) {
        this.filters = `${this.filters}&statuses=${this.status}`;
        if (this.status == 'DENIED') this.filters = `${this.filters}&statuses=DENIED_BY_STOCKOUT`;
        this.filtros.status = this.status
      }
    },
    filterPagination() {
      this.filters = `${this.filters}pageSize=${this.itemsPerPage}&`;
      this.filters = `${this.filters}page=${parseInt(this.currentPage + 1)}`;
    },
    selectPage(value) {
      this.currentPage = value;
      this.loadContracts();
    },
    selectOrder(value) {
      console.log(value);
      //Rellenar con el order cuando sepamos el formato
    },
    changeItemsPerPage() {
      this.currentPage = 0;
      this.loadContracts();
    },
    loadContracts() {
      this.filters = '';
      console.log('Inicio ' + this.filters)
      this.filterPagination();
      console.log('Pagination ' + this.filters)
      // this.filterName();
      // this.filterSurnames();
      // this.filterDocumentNumber();
      this.filterContractNumber();
      this.filterFrom();
      this.filterTo();
      // this.filterPhone();
      this.filterStatus()

      console.log('Fin ' + this.filters)

      if (this.filters !== '') {
        this.filters = `?${this.filters}`;
      }

      const vm = this;
      axios.get(`/contract/request/cancellation/search${this.filters}`)
        .then((response) => {
          vm.cancellations = response.data.responseCancellations;
          vm.totalItems = response.data.totalElements;
          vm.numberPages = vm.totalItems % vm.itemsPerPage === 0
            ? vm.totalItems / vm.itemsPerPage
            : parseInt(vm.totalItems / vm.itemsPerPage, 10) + 1;

          vm.from = (vm.currentPage * vm.itemsPerPage) + 1;
          vm.to = (vm.currentPage * vm.itemsPerPage) + vm.itemsPerPage > vm.totalItems
            ? vm.totalItems
            : (vm.currentPage * vm.itemsPerPage) + vm.itemsPerPage;
        });
    },
  },
};

</script>

<style lang="scss">
</style>
